import React from 'react';
export function FooterSection() {
  return <footer className="bg-black border-t border-zinc-900 py-12" data-id="element-181">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-182">
        <div className="text-2xl font-black text-white tracking-widest uppercase mb-6" data-id="element-183">
          Roseta <span className="text-yellow-500" data-id="element-184">Digital</span>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-8" data-id="element-185">
          <a href="#" className="hover:text-yellow-500 transition-colors" data-id="element-186">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-yellow-500 transition-colors" data-id="element-187">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-yellow-500 transition-colors" data-id="element-188">
            Contacto
          </a>
        </div>

        <p className="text-xs text-gray-600 max-w-2xl leading-relaxed mb-4" data-id="element-189">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>

        <p className="text-xs text-gray-500" data-id="element-190">
          &copy; {new Date().getFullYear()} Roseta Digital. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}